<template>
    <div class="customer-profile">
        <div class="content-area">
            <base-header
                :menu-listing="menuListing"
                @sidemenu="$emit('responsiveSideBar')"
            ></base-header>
            <div class="right-panel">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {}, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            menuListing: [
                // {
                //     anchorLink: '/billing/accounts',
                //     menuLabel: 'Accounts',
                //     name: 'view-customer-profile',
                //     permission: ['view-customer-profile'],
                // },
                // {
                //     anchorLink: '/customer-profiles/advance-search',
                //     menuLabel: 'Advance Search',
                //     name: 'advance-search',
                //     permission: ['view-customer-profile'],
                // },
            ],

            selected: '1',
        }
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {}, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {}, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
